<script lang="ts" setup>
import { computed } from 'vue';
import { useProjectStore } from '#imports';
import { useTranslationUtils } from '#layers/i18n';

export interface SpacebarItemProps {
	routeName?: string;
	routeParams?: Record<string, string>;
	label: string;
	icon?: string | null;
	active?: boolean;
	class?: string;
}

const props = defineProps<SpacebarItemProps>();

defineEmits<{
	click: [];
}>();

const { translateString } = useTranslationUtils();
const { currentProjectSlug } = useProjectStore();

const resolvedLabel = computed(() => translateString(props.label));
const resolvedIcon = computed(() => props.icon || 'lucide:file');

const resolvedRoute = computed(() => {
	if (!props.routeName) return;

	if (!currentProjectSlug.value) {
		return { name: props.routeName };
	}

	return {
		name: props.routeName,
		params: {
			project: currentProjectSlug.value,
			...props.routeParams,
		},
	};
});
</script>

<template>
	<DTooltip :text="resolvedLabel" :content="{ side: 'right' }">
		<DButton
			class="flex size-9 items-center justify-center gap-2 rounded-md p-1.5 hover:bg-elevated focus-visible:bg-elevated"
			inactive-class="hover:bg-muted"
			:class="{
				[props.class ?? '']: !!props.class,
			}"
			:active
			active-class="bg-primary/10 text-primary! hover:bg-primary/15! focus-visible:bg-primary/15!"
			variant="ghost"
			color="neutral"
			:to="resolvedRoute"
			:icon="resolvedIcon"
			:aria-label="resolvedLabel"
			size="lg"
			@click="$emit('click')"
		>
			<slot />
		</DButton>
	</DTooltip>
</template>
